import React, { useState } from 'react';
import './MyBookingQRModal.css';
import RSVPList from './RSVPList';

export default function MyBookingQRModal({ show, onClose }) {


  const [selectedTab, setSelectedTab] = useState("details");
  if (!show) return null;

  const handleOverlayClick = (e) => {
    if (e.target.classList.contains('qr-modal-overlay')) {
      onClose();
    }
  };



  return (
    <div className="qr-modal-overlay" onClick={handleOverlayClick}>
      <div className="qr-modal">
        <div className="qr-modal-tabs">
          <button
            onClick={() => setSelectedTab("details")}
            className={selectedTab === "details" ? "tab-button active" : "tab-button"}
          >
            Details
          </button>
          <button
            onClick={() => setSelectedTab("rsvp")}
            className={selectedTab === "rsvp" ? "tab-button active" : "tab-button"}
          >
            RSVP
          </button>
        </div>


        {selectedTab === "details" && (
          <div className='qr-modal-content-details'>
            <div className="ticket-card">
              {/* Header Section */}
              <div className="ticket-header">
                <img
                  src="https://images.unsplash.com/photo-1641848392593-12451ee6cd1d?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1yZWxhdGVkfDE4fHx8ZW58MHx8fHx8"
                  alt="QR Code"
                  className="ticket-image"
                />
                <div className="ticket-info">
                  <h3>Pure Vegetarian Food Party</h3>
                  <p className="ticket-subtitle">Veggies Garden Palace</p>
                  <p className="ticket-date-time">24 July 2025 | 10 PM - 01 AM</p>
                </div>
              </div>

              {/* QR Section */}
              <div className="ticket-qr-section">
                <img
                  src="https://api.qrserver.com/v1/create-qr-code/?size=200x200&data=YourEventURLHere"
                  alt="QR Code"
                  className="qr-image"
                />
                <p className="ticket-scan-text">Scan for details</p>
              </div>

              {/* Divider */}
              <div className="ticket-divider"></div>

              {/* Details Section */}
              <div className="ticket-details">
                <p><strong>Guest:{"  "}</strong> 14 Guest</p>
                <p>
                  <strong>Location:{"  "}</strong> Block K, Lajpat Nagar IV, Lajpat Nagar, New Delhi, Delhi 110048
                </p>
                <p>
                  <strong>Amount Paid:{"  "}</strong> <span className="ticket-amount">₹ 4010</span>
                </p>
              </div>
            </div>
            <div className='qr-modal-content-details-button'>
              <div className='qr-modal-content-details-button-amount'>
                <p>Remaining Amount</p>
                <p>₹ 9990</p>
              </div>
              <button className='qr-modal-content-details-button-booknow'>BookNow</button>
            </div>
          </div>
        )}

        {selectedTab === "rsvp" && (
          <>
            <RSVPList />
          </>
        )}

      </div>
    </div>
  );
}
